import { OrchestrationDownloadData } from '../../openapi/index';
import keycloakService from '../../keycloak_service';
import { sinatraOrigin } from '../../config';

export const getDownloadOrchestrationURL = (orchId: string) => {
  const data: OrchestrationDownloadData = {
    query: { id: orchId, token: keycloakService.getToken() },
  };

  const params = new URLSearchParams(data.query);

  // Unfortunately, the generated client doesn't easily expose this as a raw string.
  return `${sinatraOrigin}/v1/api/orchestration/download?${params.toString()}`;
};

export default getDownloadOrchestrationURL;
